import { Box, Card, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { TreeDataNurse } from "../data";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useSnackbar } from 'notistack';
import { nurseService } from "src/api/nurse/nurseService";
import ByzMuiSaveButton from "src/components/core-components/mui/buttons/ByzMuiSaveButton";
// import PatientCareService from "src/api/patient-care/patientCareService";

//MPOGLU;443876;19022025

interface PatientCareEditProps {
  selectedRow: TreeDataNurse | null;
  pcsid: number;
  onClose: () => void;
  onSave: (updatedRow: any) => void;
}

function PatientCareNurseEdit({ selectedRow, pcsid, onClose, onSave }: PatientCareEditProps) {
  const [reached, setReached] = useState(false);
  const [notReached, setNotReached] = useState(false);
  const [reachedNote, setReachedNote] = useState("");
  const [notReachedNote, setNotReachedNote] = useState("");
  const [continues, setContinues] = useState(false);
  const [continuesNote, setContinuesNote] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  // selectedRow değiştiğinde state'leri güncelle
  useEffect(() => {
    if (selectedRow) {
      const isReached = String(selectedRow.is_reached) === "1";
      const isNotReached = String(selectedRow.is_not_reached) === "1";
      const isContinues = String(selectedRow.is_continues) === "1";
      setReached(isReached);
      setNotReached(isNotReached);
      setContinues(isContinues);
      if (isReached) {
        setReachedNote(selectedRow.note || "");
        setNotReachedNote("");
        setContinuesNote("");
      } else if (isNotReached) {
        setNotReachedNote(selectedRow.note || "");
        setReachedNote("");
        setContinuesNote("");
      } else if (isContinues) {
        setContinuesNote(selectedRow.note || "");
        setReachedNote("");
        setNotReachedNote("");
      } else {
        setReachedNote("");
        setNotReachedNote("");
        setContinuesNote("");
      }
    } else {
      setReached(false);
      setNotReached(false);
      setContinues(false);
      setReachedNote("");
      setNotReachedNote("");
      setContinuesNote("");
    }
  }, [selectedRow]);

  //YATAY;443935;03042025
  const handleReachedChange = () => {
    if (!reached) {
      setReached(true);
      setNotReached(false);
      setContinues(false);
      setNotReachedNote("");
      setContinuesNote("");
    } else {
      setReached(false);
      setReachedNote("");
    }
  };

  //YATAY;443935;03042025
  const handleNotReachedChange = () => {
    if (!notReached) {
      setNotReached(true);
      setReached(false);
      setContinues(false);
      setReachedNote("");
      setContinuesNote("");
    } else {
      setNotReached(false);
      setNotReachedNote("");
    }
  };

  //YATAY;443935;03042025
  const handleContinuesChange = () => {
    if (!continues) {
      setContinues(true);
      setReached(false);
      setNotReached(false);
      setReachedNote("");
      setNotReachedNote("");
    } else {
      setContinues(false);
      setContinuesNote("");
    }
  };



  const getPayloadNote = () => {
    if (reached) return reachedNote;
    if (notReached) return notReachedNote;
    if (continues) return continuesNote;
    return "";
  };

  const handleSave = async () => {
    if (!selectedRow) return;
    setLoading(true);
    const now = new Date().toISOString();
    const finalNote = getPayloadNote().trim();
    const payload = {
      id: selectedRow.id,
      note: finalNote,
      isReached: reached ? "1" : "0",
      isNotReached: notReached ? "1" : "0",
      isContinuous: continues ? "1" : "0",
      period: Number(selectedRow.period || 0),
      processtime: now,
    };
    try {
      await nurseService.patientNurseCarePlan.updatePatientNurseCarePlanDetail(payload);
      enqueueSnackbar(t("messages.update-success"), { variant: "success" });
      if (onSave) {
        onSave({
          ...selectedRow,
          note: finalNote,
          is_reached: reached ? "1" : "0",
          is_not_reached: notReached ? "1" : "0",
          is_continues: continues ? "1" : "0",
          processtime: now,
          period: Number(selectedRow.period || 0),
        });
      }
      setLoading(false);
      if (onClose) onClose();
    } catch (error) {
      enqueueSnackbar(t("messages.update-error"), { variant: "error" });
      console.error(error);
      setLoading(false);
    }
  };
  const { t } = useTranslate();

  return (
    <Box>
      <Grid sx={{ margin: "2px", p: 1, borderBottom: "1px solid black" }}>
        <ByzMuiSaveButton
          onClick={handleSave}
          disabled={loading}
          loading={loading}
          popup={false}
        />
      </Grid>

      {/* YATAY;443935;03042025;TALEPTEKI TASARIMA GORE KODDA DEGISIKLIKLER YAPILDI  */}
      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container spacing={2} alignItems="stretch" sx={{ height: "100%" }}>
          <Grid item xs={7} marginTop={1} sx={{ bgcolor: "#F4F7FE" }} >
            <ByzMuiTypography variant="subtitle1">
              {t("patient-care-guide.plan-name")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5} display="flex" justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
            <ByzMuiTextField
              label={t("patient-care-guide.plan-name")}
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              margin="normal"
              value={selectedRow?.planName || selectedRow?.ncpd_name || ""}
              onChange={(e) => { }}
            />
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container alignItems="stretch" sx={{ height: "100%" }} spacing={2}>
          <Grid item xs={7} sx={{ bgcolor: "#F4F7FE" }}>
            <ByzMuiTypography variant="subtitle1" marginTop={1}>
              {t("patient-care-guide.reached")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ByzMuiCheckBox checked={reached} onChange={handleReachedChange} />

            </Grid>
            <Grid container alignItems="center">
              <ByzMuiTextField
                label={t("patient-care-guide.note")}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled={!reached}
                value={reached ? reachedNote : ""}
                onChange={(e) => setReachedNote(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container alignItems="stretch" sx={{ height: "100%" }} spacing={2}>
          <Grid item xs={7} sx={{ bgcolor: "#F4F7FE" }}>
            <ByzMuiTypography variant="subtitle1" marginTop={1}>
              {t("patient-care-guide.notreached")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ByzMuiCheckBox checked={notReached} onChange={handleNotReachedChange} />

            </Grid>
            <Grid container alignItems="center">
              <ByzMuiTextField
                label={t("patient-care-guide.note")}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled={!notReached}
                value={notReached ? notReachedNote : ""}
                onChange={(e) => setNotReachedNote(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ borderRadius: 0, height: "100%" }}>
        <Grid container alignItems="stretch" sx={{ height: "100%" }} spacing={2}>
          <Grid item xs={7} sx={{ bgcolor: "#F4F7FE" }}>
            <ByzMuiTypography variant="subtitle1" marginTop={1}>
              {t("patient-care-guide.continues")}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ByzMuiCheckBox checked={continues} onChange={handleContinuesChange} />

            </Grid>
            <Grid container alignItems="center">
              <ByzMuiTextField
                label={t("patient-care-guide.note")}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled={!continues}
                value={continues ? continuesNote : ""}
                onChange={(e) => setContinuesNote(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>

    </Box>
  );
}

export default PatientCareNurseEdit;
